import React, { useEffect, useMemo, useState } from 'react';
import CardCommon from '@op/components/CardCommon';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
import {
  RequestFuncMapType,
  useOverviewChannelOrLanguageInfo,
} from '@op/pages/Overview/KeyMetrics/hooks/channel';
import Charts from './charts';
import { downloadAction } from '@op/pages/download/utils';
import { chartTitle } from '../../utils';
import { DBO_TM } from '@op/utils/format';
import { AnalysisSummaryTypeTab } from '../../types';

interface Operation {
  symbol?: string; // 操作标识
  tip?: string; // 悬浮上去的提示
  handleClick?: (item: Operation) => void;
  icon?: string; // 操作图标
  element?: any; // 可以自定义放内容
  text?: string; // 可以自定义放内容
  placement?: string; // 气泡位置
  placementOffset?: Array<number>; // 气泡位置
  rotate?: number;
}
interface IAnalysisCharts {
  filter: any;
  titleClickFunc: () => void;
  tab: AnalysisSummaryTypeTab;
  gameInfo: any;
  title: string;
  operations: Operation[];
  defaultOperation: string;
  height: number;
  type: RequestFuncMapType;
  isLifetime: boolean;
  titleTips?: string;
}
export default function AnalysisCharts(props: IAnalysisCharts) {
  const {
    filter,
    titleClickFunc,
    tab,
    gameInfo,
    title,
    operations,
    defaultOperation,
    height = 235,
    type,
    isLifetime,
    titleTips,
    ...restProps
  } = props;
  const { formatMessage } = useLanguage();
  const [chartType, setChartType] = useState('');

  useEffect(() => {
    setChartType(defaultOperation || 'sentiment-s-bar');
  }, [defaultOperation, tab]);

  const params = useMemo(() => {
    if (type === 'language_rating') {
      return {
        ...filter,
        types: ['language'],
        is_today: DBO_TM.isToday(filter),
        need_others: true,
        need_link: false,
        need_region: false,
      };
    }

    if (['google play', 'app store', 'steam'].includes(tab)) {
      return {
        ...filter,
        should_include_lifetime: isLifetime || false,
      };
    }
    return filter;
  }, [filter, isLifetime, tab, type]);

  const { loading, chartData, empty, tableData, error } =
    useOverviewChannelOrLanguageInfo({
      filter: params,
      type,
      isSteam: tab === 'steam',
    });

  const isEmpty = useMemo(() => {
    if (empty || error) return true;

    if (chartType === 'table') {
      const list =
        type === 'language_rating' ? chartData?.rating?.tableData : tableData;
      return (list?.length || 0) === 0;
    }
    return false;
  }, [empty, error, chartData, type, chartType]);

  return (
    <CardCommon
      className={'dbo-card-common dbo-mention-sentiment-channel'}
      operations={operations}
      hasTitleArrow={!!titleClickFunc}
      loading={loading}
      loadingHeight={height}
      emptyHeight={285}
      bodyStyle={{ height: 370 }}
      empty={isEmpty}
      title={chartTitle({
        formatMessage,
        title,
        titleTipsKey: titleTips,
      })}
      handleTitleOnClick={titleClickFunc}
      operationInfo={[chartType, setChartType]}
      handleOperationsOnClick={(item) => {
        setChartType(item?.symbol || 'sentiment-s-bar');
      }}
      hasDownload={!empty}
      logBtnId="ChartCard"
      extraInfo={title}
      handleDownloadOnClick={() => {
        downloadAction({
          key: type === 'channel' ? 'KeyMetricsChannel' : 'KeyMetricsLanguage',
          fileName: 'Keyword & URL Drill',
          filter,
          auxiliaryParams: { columnsConfig: restProps?.columnsConfig || [] },
          data:
            type === 'language_rating'
              ? chartData?.rating?.tableData
              : tableData,
        });
      }}
    >
      <Charts
        chartType={chartType}
        chartData={chartData}
        tableData={tableData}
        header={title}
        filter={filter}
        type={type}
        {...restProps}
      ></Charts>
    </CardCommon>
  );
}
